import React, { FC, ReactNode } from 'react';
import { useTranslation } from '../translations';
import { classNames } from '../utils';

import './Loading.scss';

interface LoadingProps {
  readonly hideLoader?: boolean;
  readonly hideText?: boolean;
  readonly inline?: boolean;
  readonly children?: ReactNode;
}

export const Loading: FC<LoadingProps> = ({ children, inline, hideLoader, hideText }) => {
  const textColorClassNames = classNames({ 'text-light': !inline, 'text-dark': !!inline });
  const { ts } = useTranslation();

  return (
    <div
      className={classNames({
        'inline-loading': !inline,
        loading: true,
        noselect: true,
      })}
    >
      <div>
        {!hideLoader && (
          <div className={classNames({}, textColorClassNames, 'spinner-border')}>
            <span className="visually-hidden">{ts('common.loading')}</span>
          </div>
        )}
        {!hideText && (
          <div className={textColorClassNames}>{children ?? <p>{ts('common.loading')}</p>}</div>
        )}
      </div>
    </div>
  );
};
